module.exports = __webpack_public_path__ + "img/teaser_1.56516443.jpg";